import { getRequest } from './util';
var get = function (stationId) { return getRequest("/stations/".concat(stationId, "/sortingConfigAliases")); };
export default {
    get: get,
};
